import { Component, Input } from '@angular/core';

// Company-page step 7 (Client BUs) - see company-page.component.ts's
// mapping notes: this panel (company-page.html's old data-step="7") is shown
// only when TypeOfCompany is Client and isAssociatedClientUpdateInProgress.
//
// Like-for-like display port: `busOfClient` is bound by reference from the
// root legacy controller (populated via companyService.getAllBusOfClient),
// so this component only renders it - same read-only pattern as
// company-page-step-vendors.
@Component({
  selector: 'app-company-page-step-client-bus',
  templateUrl: './company-page-step-client-bus.component.html'
})
export class CompanyPageStepClientBusComponent {

  @Input() busOfClient: any[] = [];
}
